import { convexQuery } from '@convex-dev/react-query'
import { msg } from '@lingui/core/macro'
import { Trans, useLingui } from '@lingui/react/macro'
import { useQuery } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { IconUsersOutline18 } from 'nucleo-ui-outline-18'
import { SettingsPage, SettingsSection } from '~/components/settings/settings-page'
import { MemberTable } from '~/components/team/member-table'
import { Button } from '~/components/ui/button'
import { EmptyState } from '~/components/ui/empty-state'
import { Spinner } from '~/components/ui/spinner'
import { titleFor } from '~/lib/route-title'
import { useWorkspace } from '~/lib/workspace-context'
import { api } from '~convex/_generated/api'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/settings/people')({
  component: PeopleSettings,
  head: () => ({ meta: [{ title: titleFor(msg`People`) }] }),
})

function PeopleSettings() {
  const { t } = useLingui()
  const navigate = useNavigate()
  const workspace = useWorkspace()
  const { data: billing } = useQuery(
    convexQuery(api.billing.getSubscription, { workspaceId: workspace._id })
  )
  const isPersonal = billing?.status === 'free'

  return (
    <SettingsPage>
      {/* `bare`: the table frames itself, and wrapping it in the row card would
          put a border around a border. */}
      <SettingsSection bare icon={IconUsersOutline18} title={t`Members`}>
        {billing === undefined ? (
          <div className="flex justify-center py-16">
            <Spinner className="size-5" />
          </div>
        ) : isPersonal ? (
          <EmptyState
            description={t`Bring your team into one shared workspace.`}
            icon={IconUsersOutline18}
            title={t`Invite members with Professional`}
          >
            <Button
              onClick={() =>
                void navigate({
                  params: { workspaceSlug: workspace.slug },
                  to: '/$workspaceSlug/settings/billing',
                })
              }
              type="button"
            >
              <Trans>View Professional</Trans>
            </Button>
          </EmptyState>
        ) : (
          <MemberTable />
        )}
      </SettingsSection>
    </SettingsPage>
  )
}
